export default __webpack_public_path__ + "static/media/21.c12aaa07.jpg";